import {isObject} from 'lodash';

export const isPrincipia = () => {
    const roles = window._accountRoles;

    if (!isObject(roles)) {
        return false;
    }

    return roles.hasOwnProperty('principia');
}